  document.addEventListener('click', function (e) {
    const buttontarget = e.target.closest('a[href*="#klaviyo_notify"], .klaviyo_form_trigger');
    const bannertarget = e.target.getAttribute('data-url');

    if (!buttontarget && bannertarget !== '#klaviyo_notify') return;

    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'QZkHdV']);
  });